import useList from '../_basic/list';
import useItem from '../_basic/item';
import gqlItem from './item.graphql';
import gqlList from './list.graphql';

export default function(filters) {
  const group = new useItem(gqlItem);
  const groups = new useList(gqlList, filters);

  return {
    group,
    groups
  };
}
